<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/C9oG2Y/tc-custom/9781504064187.jpg?1728726194324" alt="This image is the cover for the book Job"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Job
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A woman strives for both work and love in this early novel from the author of <i>It Can’t Happen Here</i>, the first American writer to win the Nobel Prize. </b></p><p>In the early twentieth century, Una Golden leaves her small Pennsylvania hometown and heads to New York City. Her family is struggling, and Una must make money to help.</p><p>Women in the workplace are not very common—and Una is even more unusual as she enters the field of commercial real estate and impresses her bosses with her natural skills. Yet many look down on her or don’t take her seriously. They believe that women should be married, not collecting a paycheck. But Una, who would be happy to find a husband, discovers that her success may stand in the way of that dream . . .</p> One of the earliest works by the author of twentieth-century classics including <i>Main Street</i>, <i>Babbitt</i>, <i>Arrowsmith</i>, and <i>Elmer Gantry</i>, this involving, psychologically astute novel still strikes a chord more than a century after its original publication.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sinclair Lewis
      </h2>
      
      <p class="authorDescription body article">Sinclair Lewis (1885&ndash;1951) was the first American writer to win the Nobel Prize in Literature. In 1926 Lewis&rsquo;s novel <I>Arrowsmith</I> garnered the Pulitzer Prize, which the author refused. His work has been lauded for its critical insight into capitalism and materialist culture in America.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?93c15374